/** @jsx React.DOM */
var React = require('react/addons')
var TransactionLink = require('../../../partials/rmc/transaction-link')
var TransactionDescription = require('../../../partials/rmc/transaction-description')
var formatters = require('../../../helpers/formatters')
var constants = require('../../../helpers/constants')

var Transaction = React.createClass({displayName: 'Transaction',
  render: function() {
    var outer = this.props.data
    var inner = outer.tx

    return React.DOM.tr({className: "transaction"}, 
      React.DOM.td(null, 
        TransactionLink({hash: inner.hash})
      ), 
      React.DOM.td(null, 
        formatters.date(formatters.networkEpochToDate(inner.date))
      ), 
      React.DOM.td(null, 
        TransactionDescription({perspective: this.props.account, tx: outer})
      )
    )
  }
})

module.exports = Transaction



//////////////////
// WEBPACK FOOTER
// ./src/routes/rmc/account/transaction.jsx
// module id = 473
// module chunks = 0